import PropTypes from "prop-types";
import React from "react";

const FeedbackModal = ({ feedback, onClose }) => {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px",
          borderRadius: "10px",
          textAlign: "center",
          maxWidth: "90%",
          width: "400px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <h1 style={{ fontSize: "2.5rem", marginBottom: "20px" }}>
          {feedback.is_correct
            ? "¡Genial! 🎉"
            : "¡Oh no! 😢"}
        </h1>
        <p style={{ fontSize: "1.3rem", marginBottom: "20px" }}>
          {feedback.message}
        </p>
        <button
          onClick={onClose}
          style={{
            padding: "10px 20px",
            fontSize: "1.2rem",
            borderRadius: "8px",
            border: "none",
            background: "#2471A3",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Cerrar
        </button>
      </div>
    </div>
  );
};

FeedbackModal.propTypes = {
  onClose: PropTypes.func,
  feedback: PropTypes.object,
};

export default FeedbackModal;
